<template>
  <div
    class="ml-list-wrapper"
    :class="show ? 'ml-list-wrapper--empty' : 'ml-list-wrapper--full'"
  >
    <div class="bb-container bb-container--lista">
      <div class="ml-filters">
        <ListEmpty v-if="show"></ListEmpty>
        <template v-else>
          <div class="ml-filters__filters">
            <category-filter :onlyCategories="availableCategories" v-if="isBabyList"></category-filter>
            <state-filter></state-filter>
            <must-have-filter></must-have-filter>
            <search-filter></search-filter>
          </div>

          <div class="ml-filters__filters-mobile">
            <div class="ml-filters-mobile">
              <div class="ml-filters-mobile__title">{{ $t("mylist.yourList") }}</div>
              <div class="ml-filters-mobile__trigger" @click.prevent="showModal = true">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9999 8.18V3C19.9999 2.73478 19.8946 2.48043 19.707 2.29289C19.5195 2.10536 19.2651 2 18.9999 2C18.7347 2 18.4803 2.10536 18.2928 2.29289C18.1053 2.48043 17.9999 2.73478 17.9999 3V8.18C17.4208 8.3902 16.9204 8.77363 16.5668 9.27816C16.2131 9.7827 16.0234 10.3839 16.0234 11C16.0234 11.6161 16.2131 12.2173 16.5668 12.7218C16.9204 13.2264 17.4208 13.6098 17.9999 13.82V21C17.9999 21.2652 18.1053 21.5196 18.2928 21.7071C18.4803 21.8946 18.7347 22 18.9999 22C19.2651 22 19.5195 21.8946 19.707 21.7071C19.8946 21.5196 19.9999 21.2652 19.9999 21V13.82C20.5791 13.6098 21.0795 13.2264 21.4331 12.7218C21.7867 12.2173 21.9764 11.6161 21.9764 11C21.9764 10.3839 21.7867 9.7827 21.4331 9.27816C21.0795 8.77363 20.5791 8.3902 19.9999 8.18ZM18.9999 12C18.8021 12 18.6088 11.9414 18.4443 11.8315C18.2799 11.7216 18.1517 11.5654 18.076 11.3827C18.0003 11.2 17.9805 10.9989 18.0191 10.8049C18.0577 10.6109 18.153 10.4327 18.2928 10.2929C18.4327 10.153 18.6108 10.0578 18.8048 10.0192C18.9988 9.98063 19.1999 10.0004 19.3826 10.0761C19.5653 10.1518 19.7215 10.28 19.8314 10.4444C19.9413 10.6089 19.9999 10.8022 19.9999 11C19.9999 11.2652 19.8946 11.5196 19.707 11.7071C19.5195 11.8946 19.2651 12 18.9999 12ZM12.9999 14.18V3C12.9999 2.73478 12.8946 2.48043 12.707 2.29289C12.5195 2.10536 12.2651 2 11.9999 2C11.7347 2 11.4803 2.10536 11.2928 2.29289C11.1053 2.48043 10.9999 2.73478 10.9999 3V14.18C10.4208 14.3902 9.92037 14.7736 9.56676 15.2782C9.21314 15.7827 9.02344 16.3839 9.02344 17C9.02344 17.6161 9.21314 18.2173 9.56676 18.7218C9.92037 19.2264 10.4208 19.6098 10.9999 19.82V21C10.9999 21.2652 11.1053 21.5196 11.2928 21.7071C11.4803 21.8946 11.7347 22 11.9999 22C12.2651 22 12.5195 21.8946 12.707 21.7071C12.8946 21.5196 12.9999 21.2652 12.9999 21V19.82C13.5791 19.6098 14.0795 19.2264 14.4331 18.7218C14.7867 18.2173 14.9764 17.6161 14.9764 17C14.9764 16.3839 14.7867 15.7827 14.4331 15.2782C14.0795 14.7736 13.5791 14.3902 12.9999 14.18ZM11.9999 18C11.8021 18 11.6088 17.9414 11.4443 17.8315C11.2799 17.7216 11.1517 17.5654 11.076 17.3827C11.0003 17.2 10.9805 16.9989 11.0191 16.8049C11.0577 16.6109 11.153 16.4327 11.2928 16.2929C11.4327 16.153 11.6108 16.0578 11.8048 16.0192C11.9988 15.9806 12.1999 16.0004 12.3826 16.0761C12.5653 16.1518 12.7215 16.28 12.8314 16.4444C12.9413 16.6089 12.9999 16.8022 12.9999 17C12.9999 17.2652 12.8946 17.5196 12.707 17.7071C12.5195 17.8946 12.2651 18 11.9999 18ZM5.99991 6.18V3C5.99991 2.73478 5.89456 2.48043 5.70702 2.29289C5.51948 2.10536 5.26513 2 4.99991 2C4.7347 2 4.48034 2.10536 4.29281 2.29289C4.10527 2.48043 3.99991 2.73478 3.99991 3V6.18C3.42076 6.3902 2.92037 6.77363 2.56676 7.27817C2.21314 7.7827 2.02344 8.38388 2.02344 9C2.02344 9.61612 2.21314 10.2173 2.56676 10.7218C2.92037 11.2264 3.42076 11.6098 3.99991 11.82V21C3.99991 21.2652 4.10527 21.5196 4.29281 21.7071C4.48034 21.8946 4.7347 22 4.99991 22C5.26513 22 5.51948 21.8946 5.70702 21.7071C5.89456 21.5196 5.99991 21.2652 5.99991 21V11.82C6.57907 11.6098 7.07945 11.2264 7.43307 10.7218C7.78669 10.2173 7.97639 9.61612 7.97639 9C7.97639 8.38388 7.78669 7.7827 7.43307 7.27817C7.07945 6.77363 6.57907 6.3902 5.99991 6.18ZM4.99991 10C4.80213 10 4.60879 9.94135 4.44434 9.83147C4.27989 9.72159 4.15172 9.56541 4.07603 9.38268C4.00035 9.19996 3.98054 8.99889 4.01913 8.80491C4.05771 8.61093 4.15296 8.43275 4.29281 8.29289C4.43266 8.15304 4.61084 8.0578 4.80482 8.01921C4.9988 7.98063 5.19987 8.00043 5.3826 8.07612C5.56532 8.15181 5.7215 8.27998 5.83138 8.44443C5.94127 8.60888 5.99991 8.80222 5.99991 9C5.99991 9.26522 5.89456 9.51957 5.70702 9.70711C5.51948 9.89464 5.26513 10 4.99991 10Z"
                    fill="#1E0028"
                  />
                </svg>
              </div>

              <modal-dialog
                :show="showModal"
                @close="showModal = false"
                target-class="modal__card--mini"
              >
                <div class="card-filtros">
                  <h2 class="card-filtros__titulo">{{ $t("filters.filters") }}</h2>
                  <div v-if="isBabyList">
                    <category-filter></category-filter>
                  </div>
                  <state-filter></state-filter>
                  <must-have-filter></must-have-filter>

                  <div class="card-filtros__actions">
                    <button
                      class="button button--primary button--block"
                      @click="showModal = false"
                    >
                      {{ $t("generic.close") }}
                    </button>
                  </div>
                </div>
              </modal-dialog>

              <div class="ml-filters-mobile__search">
                <search-filter></search-filter>
              </div>
            </div>
          </div>

          <div v-if="!productsIsNotEmpty">
            {{ $t("mylist.noFilterResult") }}
          </div>

          <section
            class="list-section-owner"
            v-for="(group, index) in productGroups"
            :key="index"
          >
            <header class="list-section-owner__header" v-if="group[0].mainCategoryId">
              <div
                :ref="'div_accordion_' + group[0].mainCategoryId"
                @click="toggle(group[0].mainCategoryId)"
                class="bb-accordion pointer"
              >
                <div class="bb-accordion__title">
                  <h3 class="header-3 mb-0">
                    {{ group[0].mainCategory }}
                    <small>({{ group.length }})</small>
                  </h3>
                </div>

                <div v-if="!filteredByCategories" class="bb-accordion__right">
                  <img
                    :ref="'img_accordion_' + group[0].mainCategoryId"
                    src="../../../assets/img/ico/ico-chevron-up.svg"
                    width="16px"
                    height="16px"
                    class="bb-accordion__chevron bb-accordion__chevron--active"
                    alt
                  />
                </div>
              </div>
            </header>
            <main :ref="group[0].mainCategoryId" class="list-section-owner__articles">
              <template v-if="productsIsNotEmpty" v-for="(product, index) in group">
                <LazyHydrate when-visible>
                  <article class="list-section-owner__article">
                    <list-product-card
                      class=""
                      :key="index"
                      :productData="product"
                      :contributionsEnabled="
                        list.stripeAccountId != null && list.stripeAccountId != ''
                      "
                      :index="incrementProductIndex()"
                      @deleted="showDeleteProductAlert"
                    />

                    <InFeedAd
                      v-if="
                        showInFeedAd && shouldDisplayAdAfterItem(index)
                      "
                    />
                  </article>
                </LazyHydrate>
              </template>
            </main>
          </section>
        </template>
      </div>
    </div>
    <OwnerListAlert v-if="showAlertLocal" :key="key" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ModalDialog from "../../../components/ui/ModalDialog";
import LazyHydrate from "vue-lazy-hydration";
import InFeedAd from "../../adsense/InFeedAd.vue";
import CanGetCategories from "../../../Mixins/CanGetCategories";

export default {
  name: "List",
  data() {
    return {
      showModal: false,
    };
  },
  mixins: [CanGetCategories],
  components: {
    ListEmpty: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "ListEmpty" */ "./ListEmpty"
      ),
    ListProductCard: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "ListProductCard" */ "./ListProductCard"
      ),
    StateFilter: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "StateFilter" */ "../filters/StateFilter"
      ),
    CategoryFilter: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "CategoryFilter" */ "../filters/CategoryFilter"
      ),
    MustHaveFilter: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "MustHaveFilter" */ "../filters/MustHaveFilter"
      ),
    SearchFilter: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "SearchFilter" */ "../filters/SearchFilter"
      ),
    "modal-dialog": ModalDialog,
    OwnerListAlert: () =>
      import(
        /* webpackPrefetch: true */ /* webpackChunkName: "OwnerListAlert" */ "./OwnerListAlert"
      ),
    LazyHydrate,
    InFeedAd,
  },
  computed: {
    ...mapGetters({
      list: "ownerList",
      ownerProductFilters: "ownerProductFilters",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
      loggedInUserIsPremium: "loggedInUserIsPremium",
      categories: "categories",
      listType: "ownerListType",
      user: "user",
    }),
    isBabyList() {
      return this.$utils.isBabyList(this.listType);
    },
    show() {
      return this.list?.products?.length === 0;
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
    key() {
      return "deleted_product_dialog" + this.list.id;
    },
    filteredByCategories() {
      if (this.ownerProductFilters) {
        const found = this.ownerProductFilters?.find((filter) => {
          return filter.name === "category";
        });
        if (found) return true;
      }
      return false;
    },
    productsIsNotEmpty() {
      return this.filteredProducts && this.filteredProducts.length > 0;
    },
    productGroups() {
      const products = this.filteredProducts;
      if (products.length === 0) {
        return [];
      }

      const productsByCategoryId = {};
      products.forEach((product) => {
        const categoryId = product.mainCategoryId;

        if (!productsByCategoryId[categoryId]) {
          productsByCategoryId[categoryId] = [];
        }

        productsByCategoryId[categoryId].push(product);
      });

      let groups = {};
      if (productsByCategoryId[0] && productsByCategoryId[0].length > 0) {
        groups[null] = productsByCategoryId[0];
      }
      groups = {
        ...groups,
        ...Object.fromEntries(
          this.categories
            .filter(c => productsByCategoryId[c.id] && productsByCategoryId[c.id].length > 0)
            .map((category) => [
              productsByCategoryId[category.id][0].mainCategory, // Key.
              productsByCategoryId[category.id], // Value.
            ])
        ),
      };

      return groups;
    },
    availableCategories() {
      return (this.list?.products || [])
        .map(p => Number.parseInt(p.mainCategoryId, 10))
        .filter(id => !Number.isNaN(id))
        .sort((a, b) => a - b)
        .filter((id, currentIndex, arr) => arr.indexOf(id) === currentIndex);
    },
    filteredProducts() {
      let products = this.list.products || [];

      if (products.length > 0) {
        if (this.ownerProductFilters) {
          this.ownerProductFilters?.forEach((filter) => {
            if (filter.name === "state" && filter.values?.id !== 99) {
              products = products.filter((product) => product.status == filter.values.id);
            }
            if (filter.name === "category") {
              products = products.filter((product) => {
                return product.mainCategoryId === filter.values.id;
              });
            }
            if (filter.name === "search") {
              products = products.filter((product) => {
                return product.name
                  .toLowerCase()
                  .includes(filter.values.textTosearch?.toLowerCase());
              });
            }
            if (filter.name === "mustHave") {
              products = products.filter((product) => {
                return product.mustHave;
              });
            }
          });
        }
      }

      // Using `.map` to avoid mutating the original product objects.
      products = products.map((product) => ({
        ...product,

        mainCategory:
          this.getTranslatedCategory(product.mainCategoryId) || product.mainCategory,
      }));

      return products;
    },
    howManyProductsTotal() {
      return this.filteredProducts.length;
    },
    showInFeedAd() { 
      const createdAt = new Date(this.user.createdAt);
      const now = new Date();
      const hoursSinceCreation = (now - createdAt) / (1000 * 60 * 60);

      return this.howManyProductsTotal >= 5 &&
            !this.loggedInUserIsPremium &&
            hoursSinceCreation >= 24;
    },
  },
  methods: {
    incrementProductIndex() {
      const previousProductIndex = this.productIndex;
      this.productIndex++;
      return previousProductIndex;
    },
    isOpen(id) {
      let div = this.$refs[id];
      if (div) {
        return !div[0].hidden;
      }
      return false;
    },
    toggle(id) {
      let div = this.$refs[id];
      let div_accordion = this.$refs["div_accordion_" + id];
      let img_accordion = this.$refs["img_accordion_" + id];
      if (!this.isOpen(id)) {
        div[0].hidden = false;
        div_accordion[0].classList.add("bb-accordionn--open");
        img_accordion[0].classList.add("bb-accordion__chevron--active");
        return;
      }
      div_accordion[0].classList.remove("bb-accordionn--open");
      img_accordion[0].classList.remove("bb-accordion__chevron--active");
      div[0].hidden = true;
    },
    remove() {
      this.showModal = false;
    },
    showDeleteProductAlert() {
      this.$alert.success(this.$t("mylist.removeSuccess"), this.key);
    },
    shouldDisplayAdAfterItem(listItemIndex) {
      let i = 1 + listItemIndex;
      function advance(n) {
        i -= n;
      }

      advance(2);
      if (i === 0) {
        return true;
      }

      advance(3);
      if (i === 0) {
        return true;
      }

      do {
        advance(5);
      } while (i > 0);

      return i === 0;
    },
  },
  created() {
    this.productIndex = 0;
  },
  mounted() {
    const alertMessage = localStorage.getItem("alertMessage");
    const alertType = localStorage.getItem("alertType") || "success";

    if (alertMessage) {
      if (alertType == "error") this.$alert.error(alertMessage, false, this.key);
      else this.$alert.success(alertMessage, this.key);
      localStorage.removeItem("alertMessage");
      localStorage.removeItem("alertType");
    }
  },
};
</script>
